import React from 'react';
import { formatVatRate } from '../utils/settings';

const Receipt = ({
  rowCount = 3,
  sellerName = "",
  ico = "",
  dic = "",
  address = "",
  saleDate = "",
  rowsData = [],
  hasBorder = true,
  className = ""
}) => {
  const rows = Array.from({ length: rowCount }, (_, index) => {
    const rowData = rowsData[index] || {
      description: "",
      vatRate: "",
      totalPrice: ""
    };

    return (
      <tr key={index}>
        <td>{rowData.description || ""}</td>
        <td style={{ textAlign: "right" }}>{formatVatRate(rowData.vatRate)}</td>
        <td>{rowData.totalPrice || ""}</td>
      </tr>
    );
  });

  return (
    <div className={`receipt ${className} ${hasBorder ? 'with-border' : 'without-border'}`}>
      <div className="receipt-header">
        ÚČTENKA č. ____________________
      </div>
      <div className="receipt-info">
        <strong>Prodejce:</strong> {sellerName || "_______________________"}<br />
        {address && <><strong>Adresa:</strong> {address}<br /></>}
        <strong>IČO:</strong> {ico || "__________"} <strong>DIČ:</strong> {dic || "_____________"}<br />

        <strong>Datum:</strong> {saleDate || "_________________________"}
      </div>
      <table className="receipt-table">
        <thead>
        <tr>
          <th>Popis plnění</th>
          <th>DPH %</th>
          <th>Celkem</th>
        </tr>
        </thead>
        <tbody>
        {rows}
        </tbody>
      </table>
      <div className="receipt-info payment-info">
        <strong>Platba:</strong> □ Hotově  □ Převodem
      </div>
      <div className="receipt-total">
        <div>Celkem: __________ Kč</div>
      </div>
    </div>
  );
};

export default Receipt;
